import { Fragment, memo } from 'react';
import DrivingLicenseBooklet from './driving-license-booklet';
import IdentityCard from './identity-card';
import ResidencyPermit from './residency-permit';

const DocumentComponent = (): React.ReactElement => {
  return (
    <Fragment>
      <DrivingLicenseBooklet />
      <IdentityCard />
      <ResidencyPermit />
    </Fragment>
  );
};

DocumentComponent.displayName = 'Document step component';

const Document = memo(DocumentComponent);

export default Document;
